import { createWizard } from "@krakentech/blueprint-onboarding/client"
import { MeterPowerAnalysisRouteNames } from "@/routes/meterPowerAnalysis"
import { METER_POWER_ANALYSIS_DEFAULT_FORM_VALUES } from "../constants/meterPowerAnalysisDefaultFormValues"
import { MeterPowerAnalysisFormValuesSchema } from "../schemas/meterPowerAnalysisFormValuesSchema"

export const {
    useWizard: useMeterPowerAnalysisWizard,
    WizardProvider: MeterPowerAnalysisWizardProvider,
    WizardFormHydrator: HydrateMeterPowerAnalysisWizardForm,
    WizardRouteGuard: MeterPowerAnalysisWizardRouteGuard,
    wizardRouteGuardHelpers: meterPowerAnalysisWizardRouteGuardHelpers,
} = createWizard({
    storageKey: "oefr-consumer-meter-power-analysis",
    defaultFormValues: METER_POWER_ANALYSIS_DEFAULT_FORM_VALUES,
    stepNames: MeterPowerAnalysisRouteNames,
    parseFormValues: MeterPowerAnalysisFormValuesSchema.parse,
})
